// 引入通用common
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import * as types from '@/store/types';

export default {
  data() {
    return {
    };
  },
  computed: {
    // 获取登录信息
    ...mapGetters({
      localUser: types.GET_LOCALUSER,
    }),
    // 提取权限节点
    nodeArr() {
      if (this.localUser) {
        return this.localUser.node;
      }
      return [];
    },
    // 更新本地


    // 公告添加
    rbacAfficheAdd() {
      if (this.nodeArr.includes('affiche/add')) {
        return true;
      }
      return false;
    },
    // 公告修改
    rbacAfficheModify() {
      if (this.nodeArr.includes('affiche/modify')) {
        return true;
      }
      return false;
    },


    rbacStatisticsinvoicedaohang() {
      if (this.nodeArr.includes('statistics/invoicedaohang')) {
        return true;
      }
      return false;
    },
    rbacStatisticsinvoicedaishen() {
      if (this.nodeArr.includes('statistics/invoicedaishen')) {
        return true;
      }
      return false;
    },


    rbacStatisticsselltongji() {
      if (this.nodeArr.includes('statistics/selltongji')) {
        return true;
      }
      return false;
    },
    rbacStatisticssellmingxi() {
      if (this.nodeArr.includes('statistics/sellmingxi')) {
        return true;
      }
      return false;
    },
    rbacStatisticsselldaifa() {
      if (this.nodeArr.includes('statistics/selldaifa')) {
        return true;
      }
      return false;
    },


    rbacStatisticsbuyerstatshome() {
      if (this.nodeArr.includes('statistics/buyerstatshome')) {
        return true;
      }
      return false;
    },

    rbacStatisticssellzhangqi() {
      if (this.nodeArr.includes('statistics/sellzhangqi')) {
        return true;
      }
      return false;
    },

    rbacStatisticsbuyerstats() {
      if (this.nodeArr.includes('statistics/buyerstats')) {
        return true;
      }
      return false;
    },


    // 机会
    rbacCrm() {
      if (this.nodeArr.includes('crm')) {
        return true;
      }
      return false;
    },
    // 公海机会 / crm/chance
    rbacCrmchance() {
      if (this.nodeArr.includes('crm/chance')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 机会 / crm/chancestat
    rbacCrmchancestat() {
      if (this.nodeArr.includes('crm/chancestat')) {
        return true;
      }
      return false;
    },
    rbacSettingstatic() {
      if (this.nodeArr.includes('setting/static')) {
        return true;
      }
      return false;
    },
    // 查看机会客户号码的权限
    rbacCrmhopeViewContact() {
      if (this.nodeArr.includes('crm/viewhopecontact')) {
        return true;
      }
      return false;
    },
    // 查看机会客户号码的权限
    rbacCrmhopeUpdateContact() {
      if (this.nodeArr.includes('crm/update/hopecontact')) {
        return true;
      }
      return false;
    },
    // 我的意向 / crm/hope
    rbacCrmhope() {
      if (this.nodeArr.includes('crm/hope')) {
        return true;
      }
      return false;
    },
    // 我的同事 / crm/hopecolleague
    rbacCrmhopecolleague() {
      if (this.nodeArr.includes('crm/hopecolleague')) {
        return true;
      }
      return false;
    },
    // 共享到的 / crm/hopeshare
    rbacCrmhopeshare() {
      if (this.nodeArr.includes('crm/hopeshare')) {
        return true;
      }
      return false;
    },
    // 数据统计
    rbacCrmhopestat() {
      if (this.nodeArr.includes('crm/hopestat')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 我的数据 / crm/hopestat/my
    rbacCrmhopestatmy() {
      if (this.nodeArr.includes('crm/hopestat/my')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 我的同事 / crm/hopestat/colleague
    rbacCrmhopestatcolleague() {
      if (this.nodeArr.includes('crm/hopestat/colleague')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 转移日志 / crm/hopestat/log
    rbacCrmhopestatlog() {
      if (this.nodeArr.includes('crm/hopestat/log')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 意向数据库 / crm/hopestat/data
    rbacCrmhopestatdata() {
      if (this.nodeArr.includes('crm/hopestat/data')) {
        return true;
      }
      return false;
    },
    // 数据统计 - ViewLogs / crm/hopestat/viewlogs
    rbacCrmhopestatviewlogs() {
      if (this.nodeArr.includes('crm/hopestat/viewlogs')) {
        return true;
      }
      return false;
    },
    // 工具 - 全局搜索 / crm/filter
    rbacCrmfilter() {
      if (this.nodeArr.includes('crm/filter')) {
        return true;
      }
      return false;
    },
    // 工具 - 黑名单 / crm/blacklist
    rbacCrmblacklist() {
      if (this.nodeArr.includes('crm/blacklist')) {
        return true;
      }
      return false;
    },
    // 工具 - 回收站 / crm/recycle
    rbacCrmrecycle() {
      if (this.nodeArr.includes('crm/recycle')) {
        return true;
      }
      return false;
    },

    // 查看机会客户号码的权限
    rbacCrmsignViewContact() {
      if (this.nodeArr.includes('crm/viewsigncontact')) {
        return true;
      }
      return false;
    },
    // 查看机会客户号码的权限
    rbacCrmsignUpdateContact() {
      if (this.nodeArr.includes('crm/update/signcontact')) {
        return true;
      }
      return false;
    },
    // 签约
    rbacClient() {
      if (this.nodeArr.includes('client')) {
        return true;
      }
      return false;
    },
    // 我负责的 / client/sign
    rbacClientsign() {
      if (this.nodeArr.includes('client/sign')) {
        return true;
      }
      return false;
    },
    // 我的同事 / client/signcolleague
    rbacClientsigncolleague() {
      if (this.nodeArr.includes('client/signcolleague')) {
        return true;
      }
      return false;
    },
    // 共享到的 / client/signshare
    rbacClientsignshare() {
      if (this.nodeArr.includes('client/signshare')) {
        return true;
      }
      return false;
    },
    // 合同文件 / client/contract
    rbacClientcontract() {
      if (this.nodeArr.includes('client/contract')) {
        return true;
      }
      return false;
    },
    rbacClientsignstat() {
      if (this.nodeArr.includes('client/signstat')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 我的数据 / client/signstat/my
    rbacClientsignstatmy() {
      if (this.nodeArr.includes('client/signstat/my')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 我的同事 / client/signstat/colleague
    rbacClientsignstatcolleague() {
      if (this.nodeArr.includes('client/signstat/colleague')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 转移日志 / client/signstat/log
    rbacClientsignstatlog() {
      if (this.nodeArr.includes('client/signstat/log')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 签约数据库 / client/signstat/data
    rbacClientsignstatdata() {
      if (this.nodeArr.includes('client/signstat/data')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 合同库 / client/signstat/contract
    rbacClientsignstatcontract() {
      if (this.nodeArr.includes('client/signstat/contract')) {
        return true;
      }
      return false;
    },
    // 数据统计 - ViewLogs / client/signstat/viewlogs
    rbacClientsignstatviewlogs() {
      if (this.nodeArr.includes('client/signstat/viewlogs')) {
        return true;
      }
      return false;
    },
    // 工具 - 全局搜索 / client/filter
    rbacClientfilter() {
      if (this.nodeArr.includes('client/filter')) {
        return true;
      }
      return false;
    },
    // 工具 - 黑名单 / client/blacklist
    rbacClientblacklist() {
      if (this.nodeArr.includes('client/blacklist')) {
        return true;
      }
      return false;
    },
    // 工具 - 回收站 / client/recycle
    rbacClientrecycle() {
      if (this.nodeArr.includes('client/recycle')) {
        return true;
      }
      return false;
    },


    // 签到
    rbacVisit() {
      if (this.nodeArr.includes('visit')) {
        return true;
      }
      return false;
    },
    // 签到记录 / visit/record
    rbacVisitrecord() {
      if (this.nodeArr.includes('visit/record')) {
        return true;
      }
      return false;
    },
    // 事件管理 / visit/unit
    rbacVisitunit() {
      if (this.nodeArr.includes('visit/unit')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 图表统计 / visit/stat
    rbacVisitstat() {
      if (this.nodeArr.includes('visit/stat')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 图表统计 / visit/stat/tubiao
    rbacVisitstattubiao() {
      if (this.nodeArr.includes('visit/stat/tubiao')) {
        return true;
      }
      return false;
    },
    // 数据统计 - 所有签到 / visit/stat/all
    rbacVisitstatall() {
      if (this.nodeArr.includes('visit/stat/all')) {
        return true;
      }
      return false;
    },


    // 招聘
    rbacRecruitment() {
      if (this.nodeArr.includes('recruitment')) {
        return true;
      }
      return false;
    },
    // 面试安排 / recruitment/interview
    rbacRecruitmentinterview() {
      if (this.nodeArr.includes('recruitment/interview')) {
        return true;
      }
      return false;
    },
    // 人才简历 / recruitment/resume
    rbacRecruitmentresume() {
      if (this.nodeArr.includes('recruitment/resume')) {
        return true;
      }
      return false;
    },

    // 登录日志
    rbacUserlogs() {
      if (this.nodeArr.includes('user/logs')) {
        return true;
      }
      return false;
    },

    // 设置
    rbacSetting() {
      if (this.nodeArr.includes('setting')) {
        return true;
      }
      return false;
    },
    // 登录日志 / setting/logs
    rbacSettinglogs() {
      if (this.nodeArr.includes('setting/logs')) {
        return true;
      }
      return false;
    },
    // 账号统筹 / setting/account
    rbacSettingaccount() {
      if (this.nodeArr.includes('setting/account')) {
        return true;
      }
      return false;
    },
    // 访问控制 / setting/link
    rbacSettinglink() {
      if (this.nodeArr.includes('setting/link')) {
        return true;
      }
      return false;
    },
    // 角色管理 / setting/role
    rbacSettingrole() {
      if (this.nodeArr.includes('setting/role')) {
        return true;
      }
      return false;
    },
    rbacSettingfiles() {
      if (this.nodeArr.includes('setting/files')) {
        return true;
      }
      return false;
    },
    rbacSettingheadimgs() {
      if (this.nodeArr.includes('setting/headimgs')) {
        return true;
      }
      return false;
    },
    rbacSettingtimedtask() {
      if (this.nodeArr.includes('setting/timedtask')) {
        return true;
      }
      return false;
    },
    // CRM模块 / setting/crm
    rbacSettingcrm() {
      if (this.nodeArr.includes('setting/crm')) {
        return true;
      }
      return false;
    },
    // 招聘模块 / setting/recruitment
    rbacSettingrecruitment() {
      if (this.nodeArr.includes('setting/recruitment')) {
        return true;
      }
      return false;
    },

    // 添加机会客户
    rbacCrmAddchance() {
      if (this.nodeArr.includes('crm/addchance')) {
        return true;
      }
      return false;
    },
    // 添加意向客户
    rbacCrmAddhope() {
      if (this.nodeArr.includes('crm/addhope')) {
        return true;
      }
      return false;
    },
    // 添加签约客户
    rbacCrmAddsign() {
      if (this.nodeArr.includes('crm/addsign')) {
        return true;
      }
      return false;
    },


    // 公告修改
    rbacCrmsethopeshare() {
      if (this.nodeArr.includes('crm/set/hope/share')) {
        return true;
      }
      return false;
    },
    // 公告修改
    rbacCrmsetsignshare() {
      if (this.nodeArr.includes('crm/set/sign/share')) {
        return true;
      }
      return false;
    },
    // 公告修改
    rbacCrmsethopeduty_uid() {
      if (this.nodeArr.includes('crm/set/hope/duty_uid')) {
        return true;
      }
      return false;
    },
    // 公告修改
    rbacCrmsetsignduty_uid() {
      if (this.nodeArr.includes('crm/set/sign/duty_uid')) {
        return true;
      }
      return false;
    },
    // 公告修改
    rbacCrmsetchancedel() {
      if (this.nodeArr.includes('crm/set/chance/del')) {
        return true;
      }
      return false;
    },
    // 公告修改
    rbacCrmsethopedel() {
      if (this.nodeArr.includes('crm/set/hope/del')) {
        return true;
      }
      return false;
    },
    // 公告修改
    rbacCrmsetsigndel() {
      if (this.nodeArr.includes('crm/set/sign/del')) {
        return true;
      }
      return false;
    },
    // 跟进的修改
    rbacCrmTraceModify() {
      if (this.nodeArr.includes('trace/modify')) {
        return true;
      }
      return false;
    },
    // 删除跟进
    rbacCrmTraceDel() {
      if (this.nodeArr.includes('trace/del')) {
        return true;
      }
      return false;
    },


    // 新的内容
    // 设置
    rbacWarehouse() {
      if (this.nodeArr.includes('warehouse')) {
        return true;
      }
      return false;
    },

    rbacMarkting() {
      if (this.nodeArr.includes('markting')) {
        return true;
      }
      return false;
    },
    rbacMarktingemail() {
      if (this.nodeArr.includes('markting/email')) {
        return true;
      }
      return false;
    },

    rbacMarktingwebemail() {
      if (this.nodeArr.includes('markting/webemail')) {
        return true;
      }
      return false;
    },

    rbacHomesynchronousxchange() {
      if (this.nodeArr.includes('home/synchronousxchange')) {
        return true;
      }
      return false;
    },


    rbacWarehouserepertory() {
      if (this.nodeArr.includes('warehouse/repertory')) {
        return true;
      }
      return false;
    },
    // 登录日志 / setting/logs
    rbacSettingdict() {
      if (this.nodeArr.includes('setting/dict')) {
        return true;
      }
      return false;
    },
    rbacWarehousepinpai() {
      if (this.nodeArr.includes('warehouse/pinpai')) {
        return true;
      }
      return false;
    },

    rbacWarehousegoods() {
      if (this.nodeArr.includes('warehouse/goods')) {
        return true;
      }
      return false;
    },
    rbacMarkingpresented() {
      if (this.nodeArr.includes('markting/presented')) {
        return true;
      }
      return false;
    },
    rbacMarkinggroup() {
      if (this.nodeArr.includes('markting/group')) {
        return true;
      }
      return false;
    },
    rbacWarehousebill() {
      if (this.nodeArr.includes('warehouse/bill')) {
        return true;
      }
      return false;
    },
    rbacWarehousesupplier() {
      if (this.nodeArr.includes('warehouse/supplier')) {
        return true;
      }
      return false;
    },
    rbacWarehouseclearaccount() {
      if (this.nodeArr.includes('warehouse/clearaccount')) {
        return true;
      }
      return false;
    },
    rbacWarehousesearchcode() {
      if (this.nodeArr.includes('warehouse/searchcode')) {
        return true;
      }
      return false;
    },
    rbacWarehouseselllog() {
      if (this.nodeArr.includes('warehouse/selllog')) {
        return true;
      }
      return false;
    },
    rbacWarehousegoodslog() {
      if (this.nodeArr.includes('warehouse/goodslog')) {
        return true;
      }
      return false;
    },
    rbacWarehouseaccountslog() {
      if (this.nodeArr.includes('warehouse/accountslog')) {
        return true;
      }
      return false;
    },

    rbacMall() {
      if (this.nodeArr.includes('mall')) {
        return true;
      }
      return false;
    },
    rbacMallarticle() {
      if (this.nodeArr.includes('mall/article')) {
        return true;
      }
      return false;
    },
    rbacMarkingdiscounts() {
      if (this.nodeArr.includes('markting/discounts')) {
        return true;
      }
      return false;
    },

    rbacMarktingcombination() {
      if (this.nodeArr.includes('markting/combination')) {
        return true;
      }
      return false;
    },

    rbacMarktingcode() {
      if (this.nodeArr.includes('markting/code')) {
        return true;
      }
      return false;
    },

    rbacMarktingcashback() {
      if (this.nodeArr.includes('markting/cashback')) {
        return true;
      }
      return false;
    },

    rbacMarktingarticle() {
      if (this.nodeArr.includes('markting/article')) {
        return true;
      }
      return false;
    },

    rbacMallnav() {
      if (this.nodeArr.includes('mall/nav')) {
        return true;
      }
      return false;
    },
    rbacMallad() {
      if (this.nodeArr.includes('mall/ad')) {
        return true;
      }
      return false;
    },
    rbacMallcatalog() {
      if (this.nodeArr.includes('mall/catalog')) {
        return true;
      }
      return false;
    },
    rbacMallsend() {
      if (this.nodeArr.includes('mall/send')) {
        return true;
      }
      return false;
    },
    rbacMallorder() {
      if (this.nodeArr.includes('mall/order')) {
        return true;
      }
      return false;
    },
    rbacMallaccount() {
      if (this.nodeArr.includes('mall/order')) {
        return true;
      }
      return false;
    },
    rbacMallinvoice() {
      if (this.nodeArr.includes('mall/invoice')) {
        return true;
      }
      return false;
    },
    rbacMalluser() {
      if (this.nodeArr.includes('mall/user')) {
        return true;
      }
      return false;
    },

    rbacStatistics() {
      if (this.nodeArr.includes('statistics')) {
        return true;
      }
      return false;
    },

    rbacDealer() {
      if (this.nodeArr.includes('dealer')) {
        return true;
      }
      return false;
    },
    rbacDealerarticle() {
      if (this.nodeArr.includes('dealer/article')) {
        return true;
      }
      return false;
    },
    rbacDealeruser() {
      if (this.nodeArr.includes('dealer/user')) {
        return true;
      }
      return false;
    },
    rbacDealerimpower() {
      if (this.nodeArr.includes('dealer/impower')) {
        return true;
      }
      return false;
    },
    rbacDealerdiscount() {
      if (this.nodeArr.includes('dealer/discount')) {
        return true;
      }
      return false;
    },
    rbacDealerprice() {
      if (this.nodeArr.includes('dealer/price')) {
        return true;
      }
      return false;
    },
    rbacDealerorder() {
      if (this.nodeArr.includes('dealer/order')) {
        return true;
      }
      return false;
    },
    rbacDealersend() {
      if (this.nodeArr.includes('dealer/send')) {
        return true;
      }
      return false;
    },
    rbacDealeraccount() {
      if (this.nodeArr.includes('dealer/account')) {
        return true;
      }
      return false;
    },
    rbacDealerinvoice() {
      if (this.nodeArr.includes('dealer/invoice')) {
        return true;
      }
      return false;
    },

    rbacStatisticswarehouse() {
      if (this.nodeArr.includes('statistics/warehouse')) {
        return true;
      }
      return false;
    },
    rbacStatisticsdealer() {
      if (this.nodeArr.includes('statistics/dealer')) {
        return true;
      }
      return false;
    },
    rbacStatisticsmall() {
      if (this.nodeArr.includes('statistics/mall')) {
        return true;
      }
      return false;
    },


  },
  methods: {
    // 书本变量初始化mutation
    ...mapMutations({
      saveLocaluserFun: types.SAVE_LOCALUSER,
    }),
  },
};



// WEBPACK FOOTER //
// ./src/util/mix/localUserMix.js